export default __webpack_public_path__ + "static/kafkaToRedis-e1139ad47243abcc1ad67ce0277f25cc.png";